<template v-if="counterpointLoaded">
  <div uk-modal ref="verticalViewModal" id="verticalViewModal">
    <BasicModal
      class="vertical-modal"
      :isVerticalView="verticalView"
      v-if="verticalView"
      :showClose="false"
    >
      <div class="vertical-body">
        <template>
          <div
            v-if="loading"
            style="position: absolute; z-index: 15; height: 100%; width: 100%; top: 50%"
          >
            <ResourceLoadStatus :loading="loading" />
          </div>
        </template>
        <div class="uk-flex vertical-height">
          <div class="vertical-body-side-bar">
            <ul class="stepProgress">
              <li>
                <img :src="getInitialStance()" alt="" class="root-icon-size" />
                <span class="uk-background-muted root-icon-text">Round</span>
              </li>
              <li class="StepProgress-item" v-for="(round, index) in counterpoints" :key="index">
                <div style="width: 90%; margin: auto" :key="index" v-if="showLine(index)">
                  <div
                    class="vertical-line-icon"
                    :class="{
                      'vertical-line-icon-dashed': !showLine(index - 1) && index !== 0,
                      'vertical-first-line': index === 0,
                      'vertical-last-line': index === counterpoints.length - 1,
                    }"
                  ></div>
                </div>
                <div v-if="showRound(index)">
                  <BadgedIconButton
                    class="annotations-author-img uk-margin-small-right"
                    :icon="getAnnotatorRoundPlaceholder(round.round)"
                    :customTeamIcon="true"
                    :badgeValue="round.round"
                  />
                </div>
              </li>
            </ul>
          </div>
          <div
            class="uk-modal-body uk-position-relative max-width-verticle"
            id="vertical-modal-body"
          >
            <div
              uk-slider="center: true; velocity:0; finite: true"
              class="annotation-slider"
              id="root-slider"
            >
              <div
                class="root-text-excerpt-container uk-border-rounded vertical-root-text"
                id="root-text-modal"
                ref="rootTextExcerptContainer"
                @mouseleave="rootTextHoverOut"
              >
                <div v-if="rootTextExcerpt" ref="vertical-rootTextExcerpt">
                  <div class="uk-flex uk-flex-right">
                    <img
                      v-if="!pinnedRootContext"
                      src="/icons/black/icon-black-pin-angle-fill.svg"
                      @click="pinRootContext()"
                      alt="pin"
                    />
                    <span v-else uk-close @click="closeRootContext()"></span>
                  </div>
                  <p v-for="(p, index) in rootTextExcerpt.paragraphs" :key="p.paragraphId">
                    <span v-if="showEllipsesInRootTextNodeExcerpt && index == 0">...</span>
                    <span
                      v-for="node in p.nodes"
                      :key="node.nodeKey"
                      :style="{
                        background: node.underline
                          ? counterpointColors[node.counterpoints[0].team._id]
                          : undefined,
                      }"
                      :class="{
                        'vertical-underlineClass': node.underline,
                      }"
                      :id="`vertical_P_${index}_N_${node.nodeKey}`"
                      >{{ node.nodeContent }}</span
                    >
                    <span
                      v-if="
                        showEllipsesInRootTextNodeExcerpt &&
                        index == rootTextExcerpt.paragraphs.length - 1
                      "
                      >...</span
                    >
                  </p>
                </div>
              </div>
              <ul
                class="uk-slider-nav uk-dotnav uk-flex-center uk-margin rootcell-dotnav"
                @click="e => handleDotNav(e, 'root', 0)"
              />

              <div
                class="uk-position-relative"
                style="
                  padding: 20px;
                  background: rgb(225, 227, 238);
                  padding-top: 10px;
                  padding-bottom: 10px;
                "
              >
                <div style="color: black">Basis Node</div>
                <div class="uk-slider-container">
                  <ul
                    class="uk-slider-items uk-child-width-1-2 uk-child-width-1-3@s uk-child-width-1-4@m"
                  >
                    <li
                      style="width: 100%; color: black"
                      v-for="rootCell in documentData.compressedText"
                      :key="`root${rootCell.annotation._id}`"
                    >
                      <RootTextCell
                        :verticalView="true"
                        :id="`root-${rootCell.annotation._id}`"
                        :ref="`root-${rootCell.annotation._id}`"
                        :rootTextCell="rootCell"
                        :hideBoxShadow="true"
                        :author="rootCell.counterpoint.author.name"
                        @hoverIn="
                          rootTextHoverIn({ annotation: rootCell.annotation }, ...arguments)
                        "
                      />
                    </li>
                  </ul>
                </div>

                <div class="uk-visible@s">
                  <a
                    @click="annotationChange(0, 'root')"
                    class="uk-position-center-left-out uk-position-small"
                    href="#"
                    uk-slidenav-previous
                    uk-slider-item="previous"
                    style="color: black"
                  ></a>
                  <a
                    @click="annotationChange(0, 'root')"
                    class="uk-position-center-right-out uk-position-small"
                    href="#"
                    uk-slidenav-next
                    uk-slider-item="next"
                    style="color: black"
                  ></a>
                </div>
              </div>
            </div>
            <template v-for="(cpData, index) in counterpoints" :key="cpData._id">
              <div style="width: 90%; margin: auto" v-if="showLine(index)">
                <div
                  class="vertical-line"
                  :class="{ 'vertical-line-dashed': !showLine(index - 1) && index !== 0 }"
                ></div>
              </div>
              <div :ref="`cp${cpData._id}`" @mouseenter="rootTextHoverOut">
                <TransitionScroller
                  ref="virtualScrollContainer"
                  :id="`vertical_scroller_cp_${cpData._id}`"
                >
                  <div>
                    <div
                      uk-slider="center: true; velocity:0; draggable:false; finite: true"
                      class="annotation-slider"
                      :id="'annotation-slider' + (index + 1)"
                    >
                      <ul
                        class="uk-slider-nav uk-dotnav uk-flex-center uk-margin annotation-dotnav"
                        @click="e => handleDotNav(e, 'ann', index)"
                      />

                      <div class="uk-position-relative">
                        <div class="uk-slider-container">
                          <ul
                            class="uk-slider-items uk-child-width-1-2 uk-child-width-1-3@s uk-child-width-1-4@m uk-grid"
                            v-if="showRound(index)"
                          >
                            <li
                              v-for="ann in cpData.annotations"
                              :key="`ann${ann._id}`"
                              style="width: 100%; color: black"
                            >
                              <AnnotationBoxRefactored
                                v-if="publicView"
                                :id="`vertical-annotation-${ann._id}`"
                                :key="`vertical-annotation-public-${ann._id}`"
                                :ref="`annotation-${ann._id}`"
                                :annotation="ann"
                                :vertical="true"
                                :hideBoxShadow="true"
                                :disabled="isAnnotationDisabled(cpData, ann)"
                                :parentCounterpoint="ann.roundCounterpoint"
                                @resized="doAnnotationResized"
                                @hoverIn="annotationHoverIn"
                                @hoverOut="annotationHoverOut"
                              />
                              <AnnotationBoxRefactored
                                v-else
                                :id="`vertical-annotation-${ann._id}`"
                                :key="`vertical-annotation-private-${ann._id}`"
                                :ref="`annotation-${ann._id}`"
                                :annotation="ann"
                                :vertical="true"
                                :hideBoxShadow="true"
                                :disabled="isAnnotationDisabled(cpData, ann)"
                                :parentCounterpoint="ann.roundCounterpoint"
                                @resized="doAnnotationResized"
                                @hoverIn="annotationHoverIn"
                                @hoverOut="annotationHoverOut"
                                @click="
                                  showHideBubbleMenu({
                                    event: $event,
                                    menuEl: $refs.annotationsMenu.$el,
                                  })
                                "
                              />
                            </li>
                          </ul>
                          <!-- <div 
                          :key="sliderUpdated"
                          v-if="
                          style="width: 90%; margin:auto"
                        >
                            <div class="vertical-line" style="height: 100px"></div>
                        </div> -->
                        </div>

                        <div class="uk-visible@s" v-if="showRound(index)">
                          <a
                            @click="annotationChange(index, 'ann')"
                            class="uk-position-center-left-out uk-position-small"
                            href="#"
                            uk-slidenav-previous
                            uk-slider-item="previous"
                            style="color: black"
                          ></a>
                          <a
                            @click="annotationChange(index, 'ann')"
                            class="uk-position-center-right-out uk-position-small"
                            href="#"
                            uk-slidenav-next
                            uk-slider-item="next"
                            style="color: black"
                          ></a>
                        </div>
                      </div>
                    </div>
                  </div>
                </TransitionScroller>
              </div>
            </template>
            <AnnotationsBubbleMenu
              v-if="
                !publicView &&
                [PermissionLevel.TEAM_LEAD, PermissionLevel.COHORT, PermissionLevel.HOST].includes(
                  permissionLevel
                )
              "
              ref="annotationsMenu"
              :menuPosition="{ x: menuPosition.x, y: menuPosition.y }"
              :activeAnnotationId="annotationActive"
              @addAnnotation="doAddAnnotation"
              @menuHover="handleBubbleMenuHover"
              @menuLeave="handleBubbleMenuLeave"
            />
          </div>
        </div>
      </div>
    </BasicModal>
  </div>
</template>

<script>
import { defineAsyncComponent } from 'vue';
import PermissionLevel from '@/assets/js/enum/PermissionLevel';
import DocumentType from '@/assets/js/enum/DocumentType';
import { mapActions, mapState, mapGetters, mapMutations } from 'vuex';
import { EventBus } from '@/assets/js/event-bus';
import { dragElement } from '@/assets/js/utils';
import UIkit from 'uikit';
import { useDomInteractions } from '@/composables/useDomInteractions';
import BasicModal from '@/components/display/general/BasicModal.vue';
import TransitionScroller from '@/components/general/TransitionScroller.vue';
import AnnotationBoxRefactored from '@/components/annotations/AnnotationBoxRefactored.vue';
import RootTextCell from '@/components/article/RootTextCell.vue';
import AnnotationsBubbleMenu from '@/components/annotations/AnnotationsBubbleMenu.vue';
import ResourceLoadStatus from '@/components/general/ResourceLoadStatus.vue';

export default {
  name: 'AnnotationVertical',
  components: {
    BasicModal,
    TransitionScroller,
    AnnotationBoxRefactored,
    RootTextCell,
    AnnotationsBubbleMenu,
    ResourceLoadStatus,
    BadgedIconButton: defineAsyncComponent(
      () => import('@/components/display/button/BadgedIconButton.vue')
    ),
  },

  setup() {
    const {
      focusAnnotation,
      clearSelection,
      getScrollerTop,
      updateScrollerOffset,
      positionVerticalMenu,
      handleMenuResetCheck,
      handleMenuOptionCheck,
      handleMenuTargetAndPosition,
      pendingAnnotationFocus,
      shouldClearSelection,
    } = useDomInteractions();

    return {
      focusAnnotation,
      clearSelection,
      getScrollerTop,
      updateScrollerOffset,
      positionVerticalMenu,
      handleMenuResetCheck,
      handleMenuOptionCheck,
      handleMenuTargetAndPosition,
      pendingAnnotationFocus,
      shouldClearSelection,
    };
  },

  data() {
    return {
      scrollers: {},
      rootTextExcerpt: null,
      activeAnnotations: [],
      sliderUpdated: 0,
      loading: false,
      pinnedRootContext: false,
      countMouseOver: 0,
    };
  },

  computed: {
    DocumentType() {
      return DocumentType;
    },
    PermissionLevel() {
      return PermissionLevel;
    },
    UIkit() {
      return UIkit;
    },

    ...mapState([
      'counterpointData',
      'counterpointLoaded',
      'publicView',
      'menuPosition',
      'annotationHoverIds',
      'documentData',
      'verticalView',
      'verticalViewId',
      'counterpointColors',
      'annotationActive',
    ]),

    ...mapGetters([
      'isAnnotationDisabled',
      'documentSelectedSource',
      'articleExcerpt',
      'myLatestRoundNumber',
      'outlineTextNodeToOutlineNodeMapping',
      'permissionLevel',
      'getAnnotation',
    ]),

    counterpoints() {
      return this.counterpointLoaded && this.counterpointData ? this.counterpointData.rounds : [];
    },

    showEllipsesInRootTextNodeExcerpt() {
      return [DocumentType.ARTICLE, DocumentType.TEXT].includes(
        this.documentSelectedSource.sourceType
      );
    },
    roundNumber() {
      return this.counterpointData.rounds;
    },
  },

  mounted() {
    EventBus.on('vertical.row.setup', this.counterpointAnnSort);
    EventBus.on('hide.vertical.view', this.hideVerticalView);
    this.counterpointAnnSort();
    UIkit.util.on(this.$refs.verticalViewModal, 'shown', async () => {
      setTimeout(() => {
        document
          .querySelector(`#vertical-annotation-${this.verticalViewId.at(-1)} .ProseMirror`)
          ?.focus();
      }, 3000);
    });
  },
  beforeUnmount() {
    EventBus.off('vertical.row.setup', this.counterpointAnnSort);
    EventBus.off('hide.vertical.view', this.hideVerticalView);
  },
  updated() {
    setTimeout(() => {
      this.handleTextSelected();
    }, 200);
  },
  watch: {
    verticalViewId() {
      this.sliderUpdated++;
      this.showActiveAnnotations();
    },
  },

  methods: {
    ...mapMutations(['setVerticalViewId']),
    ...mapActions([
      'annotationHoverIn',
      'showHideBubbleMenu',
      'annotationHoverOut',
      'annotationFocusIn',
      'annotationFocusOut',
      'createNewHostInlineRule',
      'addAnnotation',
      'resetMenu',
      'positionMenu',
    ]),
    hideVerticalView() {
      UIkit.modal(this.$refs['verticalViewModal']).hide();
    },
    counterpointAnnSort() {
      this.counterpoints.map(cpData => {
        cpData.annotations.sort((a, b) => {
          return a.row - b.row;
        });
      });
    },
    doAnnotationResized() {
      this.$forceUpdate();
    },
    getAnnotatorRoundPlaceholder(index) {
      return index % 2 == 1 ? '/icons/icon-blue-white-bg.svg' : '/icons/icon-orange-white-bg.svg';
    },
    getInitialStance() {
      return this.documentData.initialStance === 'Host'
        ? '/icons/icon-orange-white-bg.svg'
        : '/icons/icon-blue-white-bg.svg';
    },
    handleDotNav(e, type, index) {
      if (e.target.tagName === 'LI' || e.target.tagName === 'A') {
        setTimeout(() => {
          this.annotationChange(index, type);
        }, 1000);
      }
    },

    async doAddAnnotation(annotationType) {
      this.loading = true;
      if (annotationType === 'hostInstruction') await this.createNewHostInlineRule(annotationType);
      else {
        var annotation_id = await this.addAnnotation(annotationType);
        this.getLatestAnnotationId(annotation_id);
      }
      setTimeout(() => {
        document.querySelector(`#vertical-annotation-${annotation_id} .ProseMirror`)?.focus();
      }, 1000);
      this.$forceUpdate();
      this.loading = false;
    },

    handleBubbleMenuHover(annotationId) {
      if (annotationId && this.getAnnotation(annotationId)) {
        this.annotationFocusIn(this.getAnnotation(annotationId));
      }
    },

    handleBubbleMenuLeave(annotationId) {
      setTimeout(() => {
        const annotationElement = document.getElementById(`annotation-${annotationId}`);
        if (annotationElement && !annotationElement.matches(':hover')) {
          this.annotationFocusOut();
        }
      }, 50); // Small delay to allow for mouse movement between elements
    },
    handleTextSelected() {
      if (this.rootTextExcerpt) {
        let parent = this.$refs['vertical-rootTextExcerpt'];
        Array.from(parent.children).map(child => {
          let childP = Array.from(child.children).filter(p => {
            if (p.classList.value.includes('vertical-underlineClass')) {
              return true;
            }
          });
          let lines = childP.map(child => child.getBoundingClientRect().y);
          lines = [...new Set(lines)];
          lines.map(line => {
            let data = childP.filter(child => child.getBoundingClientRect().y === line);
            data.sort((a, b) => a.getBoundingClientRect().x - b.getBoundingClientRect().x);
            data.map(elm => {
              elm.classList.remove('text-select-highlight-round-same');
              elm.classList.remove('text-select-highlight-round-begin');
              elm.classList.remove('text-select-highlight-round-end');
            });
            if (data.length === 1) {
              document.getElementById(data[0].id).classList.add('text-select-highlight-round-same');
            } else {
              document
                .getElementById(data[0].id)
                .classList.add('text-select-highlight-round-begin');
              document
                .getElementById(data.at(-1).id)
                .classList.add('text-select-highlight-round-end');
            }
          });
        });
      }
    },
    rootTextHoverIn({ annotation }) {
      if (
        [DocumentType.ARTICLE, DocumentType.TEXT].includes(this.documentSelectedSource.sourceType)
      ) {
        this.rootTextExcerpt = {
          paragraphs: Object.entries(
            this.articleExcerpt({
              start: annotation.selectedText.from.nodeOrder - 50,
              end: annotation.selectedText.to.nodeOrder + 50,
            }).reduce((acc, value) => {
              acc[value.paragraphId] = {
                paragraphId: value.paragraphId,
                nodes: [
                  ...(acc[value.paragraphId] ? acc[value.paragraphId].nodes || [] : []),
                  {
                    ...value,
                    underline:
                      value.nodeOrder >= annotation.selectedText.from.nodeOrder &&
                      value.nodeOrder <= annotation.selectedText.to.nodeOrder,
                  },
                ],
              };
              return acc;
            }, {})
          ).map(x => x[1]),
        };
      }
      if (this.documentSelectedSource.sourceType === DocumentType.OUTLINE) {
        this.rootTextExcerpt = {
          paragraphs: [
            {
              paragraphId: '0',
              nodes: this.outlineTextNodeToOutlineNodeMapping[
                annotation.selectedText.from.nodeKey
              ].map(node => ({
                ...node,
                underline:
                  node.nodeOrder >= annotation.selectedText.from.nodeOrder &&
                  node.nodeOrder <= annotation.selectedText.to.nodeOrder,
              })),
            },
          ],
        };
      }

      this.countMouseOver = setTimeout(() => {
        // const textBubbleBox = mouseEvent.target;
        //
        // display the excerpt container in order to know the height
        this.$refs.rootTextExcerptContainer.style.display = 'block';

        // setup exceprt container top or bottom position accordingly
        this.$refs.rootTextExcerptContainer.style.top = '5%';
        this.$refs.rootTextExcerptContainer.style.bottom = 'auto';
        // setup exceprt container left position
        this.$refs.rootTextExcerptContainer.style.left = `2%`;
        this.handleTextSelected();
      }, 700);
      dragElement(document.getElementById('root-text-modal'), 'root-text-modal');
      this.annotationHoverIn({ annotation });
    },

    rootTextHoverOut(event) {
      if (this.pinnedRootContext) return;
      clearTimeout(this.countMouseOver);
      this.$refs.rootTextExcerptContainer.style.display = 'none';
      this.annotationHoverOut(event);
    },
    pinRootContext() {
      this.pinnedRootContext = true;
    },
    closeRootContext() {
      this.pinnedRootContext = false;
      this.$refs.rootTextExcerptContainer.style.display = 'none';
    },
    getLatestAnnotationId(id) {
      let annArray = [];
      this.counterpointData.counterpointsFlat.map(data => {
        if (data.refAnnotation && data.refAnnotation._id === id) {
          annArray.push(data._id);
        }
      });
      if (annArray.length) {
        this.getLatestAnnotationId(annArray[0]);
      } else {
        let latestIndex = 0;
        this.counterpointData?.rounds?.map((data, index) => {
          let latestRound = data.annotations.filter(ann => ann._id === id);
          if (latestRound.length) {
            latestIndex = index;
          }
        });
        this.activeAnnotations = new Array(this.myLatestRoundNumber).fill(undefined);
        this.setActiveAnnotations(id, latestIndex);
      }
    },

    setActiveAnnotations(id, index) {
      this.counterpointData.counterpointsFlat.forEach(data => {
        if (data._id === id) {
          if (data.refAnnotation && data.refAnnotation._id) {
            this.activeAnnotations[index] = id;
            this.setActiveAnnotations(data.refAnnotation._id, index - 1);
          } else {
            this.activeAnnotations[index] = id;
            this.setVerticalViewId(this.activeAnnotations);
          }
        }
      });
    },

    showActiveAnnotations() {
      let isFirst = true;
      for (let i = 0; i < this.verticalViewId.length; i++) {
        let id = this.verticalViewId[i];
        if (id) {
          setTimeout(() => {
            if (isFirst) {
              isFirst = false;
              let rootSliderItems = document.querySelector('#root-slider .uk-slider-items');
              for (let j = 0; j < rootSliderItems.children.length; j++) {
                const elementId = rootSliderItems.children[j].children[0].id.replace(/^root-/, '');
                if (elementId === id) {
                  UIkit.slider(document.getElementById('root-slider')).show(j);
                }
              }
            }
            let sliderItems = document.querySelector(
              '#annotation-slider' + (i + 1) + ' .uk-slider-items'
            );
            for (let j = 0; j < sliderItems.children.length; j++) {
              let elmId;
              if (sliderItems.children[j].children[0].id.includes('temp')) {
                elmId = sliderItems.children[j].children[0].id.replace(/^vertical-annotation-/, '');
              } else {
                elmId = sliderItems.children[j].children[0].id.replace(/^vertical-annotation-/, '');
              }
              if (elmId === id) {
                UIkit.slider(document.getElementById('annotation-slider' + (i + 1))).show(j);
                // if(i === this.verticalViewId.length - 1) {
                //   setTimeout(() => {
                //     this.setActiveAnnotationColor()
                //   }, 2000);
                // }
              }
            }
          }, 100);
        }
      }
    },

    showRound(round) {
      if (this.verticalViewId[round]) {
        return true;
      }
      return false;
    },

    annotationChange(index, type) {
      EventBus.emit('vertical.annotation.slider');
      let slider = null;
      if (type === 'root') {
        slider = document.querySelector('#root-slider .uk-slider-items');
      } else if (type === 'ann') {
        slider = document.querySelector('#annotation-slider' + (index + 1) + ' .uk-slider-items');
      }
      for (let i = 0; i < slider.children.length; i++) {
        let elm = slider.children[i];
        setTimeout(() => {
          if (elm.className.includes('uk-active')) {
            // Extract the full ID after the prefix (root- or vertical-annotation-)
            const fullId = elm.children[0].id.replace(/^(root-|vertical-annotation-)/, '');
            this.getLatestAnnotationId(fullId);
          }
        }, 100);
      }
    },

    showLine(index) {
      return index < this.counterpoints.length && this.showRound(index);
    },
  },
};
</script>

<style lang="scss" scoped>
.main-panel {
  margin-left: 5px;
  margin-top: 120px;
  max-width: 800px;
  transition: all 0.3s ease;
  width: calc(50vw - 4rem);

  &-full-view {
    margin-left: 0vw;
    margin-right: 20vw;

    @media only screen and (max-width: 1400px) {
      margin-right: 7vw;
    }

    &-half-view {
      margin-left: 25vw;
    }

    @media only screen and (max-width: 1400px) {
      width: 441px;
    }
  }
}

.uk-button-muted {
  background: #e2e2e2 !important;
}

#switchMainPanel {
  margin-top: 0;
  margin-left: -1.5rem;
  z-index: 9;

  select {
    padding-right: 1rem;

    .button-swap {
      background: transparent;
    }

    span:last-child {
      margin-top: -0.35rem;
    }
  }
}

#toggleCounterpointSidePanelBtn {
  left: 5rem;
  position: fixed;
  transform: rotate(-90deg);
  transform-origin: bottom left;
  top: calc(20rem + 2px);
  z-index: 1;
}

.topbar-publicview {
  margin-top: -91px;
  width: 100%;
}

.topbar-showingsidepanel {
  width: 25.7%;
}

.topbar-mainpanel {
  width: 42.7%;
}

.vertical-modal {
  width: 1000px;
  height: 83.5%;
  overflow-y: scroll;
  position: absolute;
  z-index: 9;
  left: 33%;
  padding: 0;
  min-width: 800px;
  min-height: 600px;
  border-radius: 0px;

  &::-webkit-scrollbar {
    display: none;
  }
}

.vertical-body {
  height: 100vh;
}

.annotation-slider {
  width: 90%;
  margin: auto;
  position: relative;
}

.annotation-dotnav {
  position: absolute;
  top: 15px;
  z-index: 2;
  width: 100%;
  margin: unset !important;
}

.rootcell-dotnav {
  position: absolute;
  top: 76px;
  z-index: 2;
  width: 100%;
  margin: unset !important;
}

.root-text-excerpt-container {
  display: none;
  position: absolute;
  background: #ffffff;
  z-index: 110;
  min-width: 300px;
  max-width: 50vw;
  border: 0.5px solid #000000;
  padding: 10px;

  p {
    margin: 10px 0 10px 0 !important;
  }
}

.vertical-annotation-box {
  margin-top: 0px !important;

  .text-bubble {
    transform: translateY(0px) !important;
  }
}

.vertical-line {
  height: 35px;
  width: 1px;
  margin: auto;
  border-left: 1px gray solid;

  &-dashed {
    border-left: 1px gray dashed;
  }
}

.vertical-line-icon {
  height: 132px;
  width: 10px;
  margin: auto;
  border-left: 2px gray solid;

  &-dashed {
    height: 175px;
    border-left: 2px gray dashed;
  }
}

.vertical-first-line {
  height: 175px;
  width: 10px;
  margin: auto;
  border-left: 2px gray solid;

  &-dashed {
    border-left: 2px gray dashed;
  }
}

.vertical-last-line {
  height: 155px;
  width: 10px;
  margin: auto;
  border-left: 2px gray solid;

  &-dashed {
    border-left: 2px gray dashed;
  }
}

.uk-slidenav-previous {
  margin-right: 5px;
}

.uk-slidenav-next {
  margin-left: 5px;
}
</style>

<style lang="scss">
.uk-dotnav > li {
  padding: 0 6px !important;
}

.vertical-annotation-box .text-bubble {
  transform: translateY(0px) !important;
}

.vertical-body-side-bar {
  background: #2c3157;
  padding: 100px 20px 10px 10px;
}

.vertical-height {
  min-height: 100%;
}

.stepProgress {
  position: relative;
  list-style: none;
}

.root-icon-text {
  padding: 4px 12px 4px 12px !important;
  color: #2c3157 !important;
  font-size: $global-small-font-size;
  border-radius: 15px;
  transform: translate(-51px, 40px);
  position: absolute;
  font-weight: bold;
  background: #d9d9d9;
}

.root-icon-size {
  width: 2rem;
}

.max-width-verticle {
  overflow-y: scroll;
  width: 100%;
  max-width: calc(100% - 110px);

  @media only screen and (max-width: 1550px) {
    padding: 30px 1px !important;
  }
}

.text-select-highlight-round {
  &-same {
    border-radius: 20px;
    width: calc(100% + 16px);
    padding: 0 8px 0 8px;
  }

  &-begin {
    border-radius: 20px 0 0 20px;
    padding-left: 8px;
  }

  &-end {
    border-radius: 0 20px 20px 0;
    padding-right: 11px;
  }
}
</style>
